import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation, withTranslation } from "react-i18next";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import useModal from "hooks/useModal";
import { showErrorNotification } from "store/notifications/actions";
import { downloadReport } from "apis/reports";

function DownloadFileType({ selectedValues, report }) {
  const dispatch = useDispatch();
  const [show, toggle] = useModal();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const fileTypes = ["csv", "pdf", "xlsx"];

  return (
    <React.Fragment >
      <div>
        <Button
          color="primary"
          size="sm"
          disabled={!selectedValues.reportType || report?.loading || !!report?.error}
          onClick={toggle}
        >
          {t("Download Report")}
        </Button>
      </div>
      <Modal isOpen={show} toggle={toggle} centered={true}>
        <ModalHeader toggle={toggle}>
          {t("Download Report")}
        </ModalHeader>
        <ModalBody >
          <AvForm onValidSubmit={(e, v) => {
            const fileType = v.fileType;
            setLoading(true);
            downloadReport({
              ...selectedValues,
              fileType
            }).then((blob) => {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              const operationMt5Type = selectedValues.reportType === "mt5-operations" ?  "-" + selectedValues.operationType.toLowerCase()  : "";
              link.setAttribute(
                "download",
                `${selectedValues.reportType}${operationMt5Type}.${fileType}`
              );
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);
              setLoading(false);
            }).catch((error) => {
              dispatch(showErrorNotification(error?.message || t("Download failed")));
              setLoading(false);
            });
          }} >
            <AvField
              name="fileType"
              label={t("File Type")}
              type="select"
              value="xlsx"
              required
            >
              {fileTypes.map((type) => (
                <option key={type} value={type}>{type.toUpperCase()}</option>
              ))}
            </AvField>
            <ModalFooter className="d-flex justify-content-center pb-0">
              <Button type="submit" color="primary" 
                disabled={loading}>
                {loading ? <i className="fa fa-spinner fa-spin" /> : t("Download")}
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment >
  );
}

export default withTranslation()(DownloadFileType);
